module.exports = __webpack_public_path__ + "static/media/confirm-info-empty-screen.4f690b09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/confirm-info-empty-screen.svg
// module id = 793
// module chunks = 0